var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mw-login\">\n<div class=\"mw-login-content\">\n<img class=\"mw-login-logo\" src=\"" + require("hapara-assets/src/images/logo-hapara.svg") + "\" alt=\"\"/>\n<div class=\"login-buttons\">\n<div id=\"googleLogInButton\"></div>\n</div>\n</div>\n</div>\n";
var id1="app/user/login.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;